<template>
    <div :class="inputClass">
        <p class="mb-1 mt-10"
            v-html="label"
            :class="{ 'required-input': mandatory }"/>
        <textarea
            :rows="rows"
            :id="`${_uid}-input`"
            class="input__textarea"
            maxlength="250"
            v-model="val"
            :placeholder="placeholder"/>

        <!-- Validation -->
        <p class="input__message"
           v-if="message"
           v-text="message"/>
    </div>
</template>

<script>
export default {
    name: 'TextboxField',
    data: () => {
        return {
            val: null,
        };
    },
    props: {
        value: {
            required: true,
        },
        label: {
            default: null,
            type: String,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
        rows: {
            type: Number,
            default: 4,
        },
        placeholder: {
            type: String,
            default: null,
        },
        message: {
            type: String,
            default: null,
        },
        mandatory: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        inputClass() {
            if (this.value === null && this.isValid === true) {
                return 'input';
            }

            return this.isValid && this.value !== '' ? 'input input--success' : 'input input--invalid';
        },
    },
    watch: {
        val(value) {
            this.$emit('input', value);
        },
        value: {
            immediate: true,
            handler(value) {
                this.val = value;
            },
        },
    },
};
</script>
